import axios from 'axios';
import config from '@/config';

const teamsApi = axios.create({
  baseURL: config.apiUrl,
  headers: {
    'X-Teams-Tab': '1',
  },
});

teamsApi.interceptors.request.use((conf) => {
  const customConfig = conf;
  const token = sessionStorage.getItem('@Teams:token');
  if (token) {
    customConfig.headers = customConfig.headers || {};
    customConfig.headers.Authorization = `Bearer ${token}`;
  }
  return customConfig;
});

teamsApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      sessionStorage.removeItem('@Teams:token');
      sessionStorage.removeItem('@Teams:expires_at');
      sessionStorage.removeItem('@Teams:usuario');
      sessionStorage.removeItem('@Teams:conversa_id');
      sessionStorage.removeItem('@Teams:requisicao_id');
    }
    return Promise.reject(error);
  },
);

export default teamsApi;
